import Form from "./components/Form"

function App() {
  return (
    <div>
      <header>
        <h1>Client Offer Form</h1>
        <Form />
      </header>
    </div>
  )
}

export default App
